/*
 * File: StoryComponent.styles.js
 * Project: our-wave-stories-app
 *
 * Created by Brendan Michaelsen on February 7, 2022 at 1:53 PM
 * Copyright © 2022 Our Wave, Inc. All rights reserved.
 *
 * Last Modified: May 26, 2025 at 2:52 PM
 * Modified By: Brendan Michaelsen
 */

/**
 * Imports
 */

// Modules
import styled from 'styled-components';

// Components
import { IconButton } from '../IconButton';


/**
 * Styles
 */

export const Wrapper = styled.div``;

export const CardHeader = styled.div`
	position: relative;
	display: flex;
	align-items: center;
	gap: 12px;
	margin: 0px 0px 12px;
`;

export const Spacer = styled.div`
	flex-grow: 1;
`;

export const BackButton = styled(IconButton)`
	background-color: ${({ theme }) => theme.neutralButton};
	border-radius: 50%;
	width: 30px;
	height: 30px;
	display: flex;
	align-items: center;
	justify-content: center;
`;

export const PromptContainer = styled.div`
	flex-grow: 1;
	display: flex;
	align-items: center;
	gap: 8px;
	margin: 20px 0px 10px;

	h5 {
		text-transform: uppercase;
		font-size: 0.7rem;
		color: ${({ theme }) => theme.secondaryText};
	}
`;

export const ActionBar = styled.div`
	display: flex;
	flex-wrap: wrap;
	gap: 10px;
	margin: 20px 0px 0px;
	align-items: center;

	.love {
		font-size: 1.0rem;
	}
	.comment {
		font-size: 1.0rem;
	}
	.active {
		color: ${({ theme }) => theme.brandHighlight}
	}
`;

export const BadgeContainer = styled.div`
	display: flex;
	flex-wrap: wrap;
	gap: 6px;

	span {
		cursor: pointer;
	}

	.rightIcon {
		svg {
			font-size: 0.7rem;
		}
		span {
			font-size: 0.8rem;
			margin-right: 4px;
		}
		& > span {
			margin: 0px;
		}
	}
	.leftIcon {
		svg {
			font-size: 0.7rem;
		}
		span {
			font-size: 0.8rem;
			margin-left: 6px;
		}
		& > span {
			margin: 0px;
		}
	}
`;

export const ActionSpacer = styled.div`
	flex-grow: 1;
`;

export const CommentsContainer = styled.div`
	position: relative;
	margin: 30px 0px 20px;
`;

export const CommentSignpost = styled.div`
	position: relative;
`;

export const CommentsDisabledLabel = styled.div`
	p {
		color: ${({ theme }) => theme.secondaryText};
	}
`;

export const StoryColumnContainer = styled.div`
	display: flex;
`;

export const StoryTimelineColumn = styled.div`
	margin: 0px 8px 0px 0px;
	display: flex;
	flex-direction: column;
	align-items: center;
	position: relative;
	width: 28px;
`;

export const StoryContentColumn = styled.div`
	flex-grow: 1;
	padding: 50px 0px 10px;
`;

export const TimelineNodeLabel = styled.div`
	border-radius: 4px;
	position: absolute;
	left: 12px;
	top: 0px;
	height: 28px;
	z-index: 1;
	padding: 0px 12px 0px 17px;
	display: flex;
	align-items: center;
	justify-content: center;

	p {
		margin: 0px;
		white-space: nowrap;
		font-size: 0.9rem;
		color: ${({ theme }) => theme.secondaryText};
	}
`;

export const TimelineNode = styled.div`
	width: 28px;
	height: 28px;
	border-radius: 50%;
	display: flex;
	align-items: center;
	justify-content: center;
	position: relative;
	z-index: 2;
	margin: 0px 0px 6px;

	svg {
		margin-top: 1px;
		font-size: 16px;
		color: ${({ theme }) => theme.secondaryText};
	}
`;

export const TimelineLine = styled.div`
	width: 2px;
	background-color: ${({ theme }) => theme.layoutBorder};
	flex-grow: 1;
`;

export const TimelineLineCap = styled.div`
	width: 8px;
	height: 8px;
	border-radius: 50%;
	background-color: ${({ theme }) => theme.layoutBorder};
`;

export const StoryContainer = styled.div`
	user-select: none;
	white-space: pre-wrap;
	display: flex;
	flex-direction: column;
	gap: 20px;

	p {
		line-height: 180%;
	}
`;

export const StoryUpdatesSignpost = styled.div`
	position: relative;
`;
